<style>
</style>

<script>
    import {push} from './pt-router/Router.svelte'
    import {onMount} from 'svelte'
    import * as Common from './Common.js'
    import InboxItem from './InboxItem.svelte'
    import Spinner from './Spinner.svelte'

    let notifications = null

    onMount(async () => {
        if(!Common.currentUserValue) {
            Common.loginContext.update(l => 'inbox')
            push('/login')
            return
        }

        Common.getData('notification')
        .then(data => {
            notifications = data.sort((a,b) => b.id - a.id)
        })
    })
</script>

<div class="holder">
    <h1>Inbox</h1>
    {#if !notifications}
        <Spinner></Spinner>
    {:else if notifications && notifications.length != 0}
        {#each notifications as n}
            <InboxItem bind:notification={n}></InboxItem>
        {/each}
    {:else}
        Your Inbox is Empty.
    {/if}
</div>